import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FacebookSDKContext } from './context';

function loadScript(src, async = true, defer = true) {
  var tag = document.createElement('script');
  tag.async = async;
  tag.src = src;
  tag.defer = defer;
  document.querySelector('body').appendChild(tag);
}

const localStorage = window.localStorage;

export default class FacebookProvider extends Component {
  static propTypes = {
    appId: PropTypes.string.isRequired,
    version: PropTypes.string,
  };

  static defaultProps = {
    version: 'v3.3',
  };

  state = {
    FB: null,
    accessToken: localStorage.getItem('fbacc'),
  };

  componentDidMount() {
    const { appId, version } = this.props;
    loadScript('https://connect.facebook.net/en_US/sdk.js');
    if (window) {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: appId,
          autoLogAppEvents: true,
          xfbml: true,
          version,
        });
        this.setState({ FB: window.FB });
      };
    }
  }

  handleSetFacebookToken = token => {
    localStorage.setItem('fbacc', token);
    this.setState({ accessToken: token });
  };

  handleClearFacebookToken = () => {
    localStorage.removeItem('fbacc');
    this.setState({ accessToken: null });
  };

  handleGetUserProfile = (fields = [/*'gender',*/ 'short_name', 'email']) => {
    const { FB, accessToken } = this.state;
    if (accessToken !== null && accessToken !== undefined) {
      return new Promise((resolve, reject) => {
        FB.api('/me', { fields, access_token: accessToken }, response => {
          const { error } = response;
          if (!error) {
            console.log(response);
            return resolve(response);
          } else {
            console.error(error);
            return reject(response);
          }
        });
      });
    } else {
      return Promise.reject({ error: 'No Access Token' });
    }
  };

  render() {
    const { FB, accessToken } = this.state;
    return (
      <FacebookSDKContext.Provider
        value={{
          FB,
          accessToken,
          setFacebookToken: this.handleSetFacebookToken,
          clearFacebookToken: this.handleClearFacebookToken,
          getUserProfile: this.handleGetUserProfile,
        }}
      >
        {this.props.children}
      </FacebookSDKContext.Provider>
    );
  }
}
